'use strict';
window.uomedia = window.uomedia || {};
var Cookies = Cookies || null;
(($) => {
  $('.site-alert').each(function () {
    const $this = $(this);
    // check cookies to see if user has already dismissed the alert
    if (Cookies && Cookies.get('alertVisible-' + $this.attr('id'))) {
      $this.hide();
    } else {
      $this.show();
    }
  });

  $('.site-alert .btn-close').on('click', function () {
    const $alert = $(this).closest('.site-alert');
    const cookie = 'alertVisible-' + $alert.attr('id');
    $alert.hide();
    if(Cookies) {
      Cookies.set(cookie, false);
    }
  });
})(jQuery);
